import { create } from "zustand"
import { persist } from "zustand/middleware"

export type Theme = "light" | "dark" | "system"

const prefersDark = () => window.matchMedia("(prefers-color-scheme: dark)").matches

/** Returns whether the given theme setting should render dark right now. */
export const resolveIsDark = (theme: Theme) =>
  theme === "dark" || (theme === "system" && prefersDark())

/** Adds/removes the `dark` class on <html> to match the theme setting. */
export const applyTheme = (theme: Theme) => {
  document.documentElement.classList.toggle("dark", resolveIsDark(theme))
}

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "system",
      setTheme: (theme) => {
        applyTheme(theme)
        set({ theme })
      }
    }),
    {
      name: "theme-store",
      onRehydrateStorage: () => (state) => {
        applyTheme(state?.theme ?? "system")
      }
    }
  )
)
